import React from 'react';
import { Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import './tools.css';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Tools = () => {
  return (
    <div className="tools-sec" id="tool-section">
    <Container>
       <Grid>
       <Typography variant="h4" className="tool-heading" data-aos="zoom-out" data-aos-duration="3000">
          Frameworks  <span>AND TOOLS .</span>
       </Typography>
       <div className='icon-sec' data-aos="fade-up">
       <Swiper
        // slidesPerView={4}
        // spaceBetween={3}
        // slidesPerGroup={4}
        loop={true}
        // loopFillGroupWithBlank={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          0:{
            slidesPerView:3
          },
          600:{
            slidesPerView:6
          },
          850:{
            slidesPerView:8
          },
          1150:{
            slidesPerView:10
          },
          1700:{
            slidesPerView:10
          },
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
        >
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/docker.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Docker</Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/git.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Git </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/firebase.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Firebase </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/jira.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Jira </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/gitlab.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Git Lab </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/bitbucket.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Bit Bucket </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/github.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Git Hub </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/mui.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> MUI </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/antd.svg" alt="docker" className='tool-img' />
            <Typography variant="h6"> AntD </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/bootstrap.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> BootStrap </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/nextjs.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Next JS </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/strapi.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Strapi </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/mongoose.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Mongoose </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/redux.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Redux </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/prisma.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Prisma </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/clickup.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Click Up </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/photoshop.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> PhotoShop </Typography>
          </div>  
          </SwiperSlide>  
          <SwiperSlide>
          <div className="tool-box">
            <img src="./icons/postman.png" alt="docker" className='tool-img' />
            <Typography variant="h6"> Postman </Typography>
          </div>  
          </SwiperSlide>  

        </Swiper>
       </div>

        </Grid>
    </Container>      
    </div>
  )
}

export default Tools
